if (!customElements.get('kg-party-builder')) {
  customElements.define('kg-party-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.inputs = [...this.querySelectorAll('[data-count]')];
      this.targetInput = this.querySelector('[data-target]');
      this.storageKey = 'kg-party-preview-v1';
      this.pack = 'custom';
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
        if (saved && ['12','18','24','custom'].includes(saved.pack)) {
          this.pack = 'custom';
          this.targetInput.value = Number.isInteger(saved.target) && saved.target >= 0 && saved.target <= 9999 ? saved.target : 25;
          this.inputs.forEach(input => { const value = saved.counts?.[input.dataset.count]; input.value = Number.isInteger(value) && value >= 0 && value <= 9999 ? value : 0; });
        }
      } catch {}
      const restore = new URLSearchParams(location.search);
      const restoreKeys = ['kg_target', 'kg_mimosa', 'kg_basil', 'kg_radish'];
      if (restoreKeys.every(key => restore.has(key) && /^\d{1,4}$/.test(restore.get(key)))) {
        const target = Number(restore.get('kg_target'));
        if (target >= 25 && target <= 9999) {
          this.targetInput.value = target;
          this.inputs.forEach(input => { input.value = Number(restore.get(`kg_${input.dataset.count}`)); });
        }
      }
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        if (button.hasAttribute('data-add')) { this.addToCart(); return; }
        if (button.dataset.pack) { this.pack = button.dataset.pack; this.update(); return; }
        if (button.dataset.fill) {
          const count = this.validTarget() ? this.target() : 0;
          const action = button.dataset.fill;
          this.inputs.forEach((input, i) => { input.value = action === 'mix' ? Math.floor(count / 3) + (i < count % 3 ? 1 : 0) : action === input.dataset.count ? count : 0; });
        }
        if (button.dataset.step) {
          const input = this.inputs.find(item => item.dataset.count === button.dataset.seed);
          const increase = Number(button.dataset.step);
          const available = Math.max(0, this.target() - this.selected());
          const next = Math.max(0, this.count(input) + increase);
          if (increase < 0 || available > 0 && this.validTarget()) input.value = next;
        }
        this.update();
      });
      this.addEventListener('input', event => {
        if (event.target.matches('[data-count]')) {
          const n = Number(event.target.value);
          if (event.target.value !== '' && Number.isFinite(n)) event.target.value = Math.min(9999, Math.max(0, Math.floor(n)));
        }
        this.update();
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-count]') && event.target.value === '') event.target.value = 0;
        this.update();
      });
      this.update();
    }
    async addToCart() {
      if (this.busy || this.dataset.orderable !== 'true' || !this.dataset.variant || !this.validTarget() || this.selected() !== this.target()) return;
      const properties = { 'Basil kits': String(this.count(this.inputs.find(input => input.dataset.count === 'basil'))), 'Mimosa kits': String(this.count(this.inputs.find(input => input.dataset.count === 'mimosa'))), 'Cherry Radish kits': String(this.count(this.inputs.find(input => input.dataset.count === 'radish'))), 'Total grow kits': String(this.target()), '_kg_custom_mix': 'v1', '_kg_mix_id': crypto.randomUUID() };
      const button = this.querySelector('[data-add]'), error = this.querySelector('[data-error]');
      this.busy = true; error.hidden = true; button.textContent = this.dataset.labelAdding; this.update();
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(this.dataset.variant), quantity: this.target(), properties }] }) });
        if (!response.ok) throw new Error('Cart unavailable');
        location.assign(this.dataset.cartUrl);
      } catch {
        error.textContent = this.dataset.labelError; error.hidden = false;
        this.busy = false; button.textContent = this.dataset.labelAdd; this.update();
      }
    }
    target() { return Number(this.targetInput.value); }
    count(input) { const value = Number(input.value); return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0; }
    selected() { return this.inputs.reduce((total, input) => total + this.count(input), 0); }
    validTarget() { const n = this.target(); return this.targetInput.value !== '' && Number.isInteger(n) && n >= 25 && n <= 9999; }
    update() {
      this.querySelectorAll('[data-pack]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pack === this.pack)));
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== this.pack; });
      const target = this.target(), selected = this.selected(), valid = this.validTarget();
      this.querySelector('[data-add]').disabled = this.dataset.orderable !== 'true' || !valid || selected !== target || this.busy;
      const format = (message, values) => Object.entries(values).reduce((text, [key,value]) => text.replaceAll(`{${key}}`, value), message);
      this.querySelector('[data-selection]').textContent = format(this.dataset.labelSelected, { selected, target: valid ? target : '—' });
      const difference = target - selected;
      this.querySelector('[data-status]').textContent = !valid ? this.dataset.labelMin : difference > 0 ? format(this.dataset.labelRemaining, {count:difference}) : difference < 0 ? format(this.dataset.labelOver, {count:-difference}) : this.dataset.labelReady;
      this.querySelector('.kgd-builder-summary').dataset.valid = String(valid && difference === 0);
      this.targetInput.setAttribute('aria-invalid', String(!valid));
      this.querySelector('[data-progress]').max = valid ? target : 25;
      this.querySelector('[data-progress]').value = valid ? Math.min(selected,target) : 0;
      this.querySelector('[data-total]').textContent = valid ? `${this.dataset.currency} ${(target * Number(this.dataset.unitPrice) / 100).toFixed(2)}` : '—';
      this.querySelectorAll('[data-step]').forEach(button => {
        const input = this.inputs.find(item => item.dataset.count === button.dataset.seed);
        button.disabled = Number(button.dataset.step) < 0 ? this.count(input) <= 0 : !valid || selected >= target;
      });
      this.querySelectorAll('[data-fill]').forEach(button => { button.disabled = button.dataset.fill !== 'clear' && !valid; });
      try { sessionStorage.setItem(this.storageKey, JSON.stringify({pack:this.pack,target,counts:Object.fromEntries(this.inputs.map(input => [input.dataset.count,this.count(input)]))})); } catch {}
    }
  });
}
